export const getAuth = state => state.auth;
export const isLoading = state => getAuth(state).isLoading;
export const getError = state => getAuth(state).error;
export const isLoggedIn = state => getAuth(state).isLoggedIn;
export const getToken = state => getAuth(state).token;
export const getRefreshToken = state => getAuth(state).refreshToken;
